import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import MyButton from "./MyButton";

class ConfirmDialog extends React.Component {
    constructor(props) {
      super(props);
      this.handleCancel = this.handleCancel.bind(this);
      this.handleOK = this.handleOK.bind(this);
      this.state = {};
    }
    componentDidMount() {

    }   
    static getDerivedStateFromProps(props, state) {
        return state;
    }
    handleCancel = () => {
        this.props.callback(false);
    }
    handleOK = () => {
        this.props.callback(true);
    }
    render() {
        return <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
        open={true}
      >
        <DialogTitle id="confirmation-dialog-title">Xác nhận</DialogTitle>
        <DialogContent dividers>
            <div>
                {this.props.message}
            </div>
        </DialogContent>
        <DialogActions>
            <MyButton onClick={this.handleOK} color="primary" text="OK" />
          <MyButton onClick={this.handleCancel} color="primary" text="Cancel" />
          
        </DialogActions>
      </Dialog>
    }
}
export default ConfirmDialog;